import { useContext, useEffect } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { env } from '../config/runtime';
import { RecaptchaContext } from './RecaptchaContext';

const BADGE_STYLE_ID = 'recaptcha-badge-hide';

function hideBadge() {
  if (document.getElementById(BADGE_STYLE_ID)) {
    return;
  }
  const style = document.createElement('style');
  style.id = BADGE_STYLE_ID;
  style.textContent = '.grecaptcha-badge { visibility: hidden !important; }';
  document.head.appendChild(style);
}

export function RecaptchaProvider({ children }: { children: React.ReactNode }) {
  const siteKey = env.recaptchaSiteKey;
  const alreadyMounted = useContext(RecaptchaContext);

  useEffect(() => {
    if (siteKey) {
      hideBadge();
    }
  }, []);

  // Two `GoogleReCaptchaProvider`s share one global `grecaptcha`, and minting then throws for both.
  // Guards only nested providers via context — a sibling mount (e.g. StepUpDialog, rendered next
  // to `children` in StepUpProvider) won't see this and can still double-mount. Not possible today
  // (no RecaptchaProvider page currently triggers step-up), but check this if that changes.
  if (alreadyMounted || !siteKey) {
    return children;
  }

  return (
    <RecaptchaContext.Provider value={true}>
      <GoogleReCaptchaProvider reCaptchaKey={siteKey}>{children}</GoogleReCaptchaProvider>
    </RecaptchaContext.Provider>
  );
}
